import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fix' })
export class FixFormatPipe implements PipeTransform {
    transform(value: number, digits = 1): string {
        return (value ?? 0).toLocaleString('en-US', {
            notation: 'standard',
            maximumFractionDigits: digits,
            minimumFractionDigits: digits
        });
    }
}

@Pipe({ name: 'varfix' })
export class VarFixFormatPipe implements PipeTransform {
    static convert(value: number, digits = 5) {
        value ??= 0;

        let d = 0;
        let r = Math.floor(value);
        let baseDigits = r.toString().length - 1;
        r = value - r;
        let started = false;
        while (r != 0 && d + baseDigits < digits) {
            if (started)
                d++;
            r *= 10;
            if (Math.floor(r) == 0)
                continue;
            if (!started)
                started = true;

        }
        return value.toFixed(d);
    }
    transform(value: number, digits = 5): string {
        return VarFixFormatPipe.convert(value, digits);
    }
}
